
import currencyConverter from "../common/currency-converter.vue";
export default {
  components: { currencyConverter },
  props: {
    categoryObj: {
      default: {}
    },
    totCol: {
      default: 0
    },
    color: {
      default: ""
    },
    bgColor: {
      default: ""
    },
    itemTotalPrice: {
      default: 0
    },
    isOpen: {
      default: true
    },
    type: {
      default: ""
    },
    printMode: {
      default: false
    }
  },
  computed: {
    isCategory() {
      return this.type == "category";
    },
    revenueContribution() {
      return (
        Math.round(
          (this.categoryObj?.totalAmount / this.itemTotalPrice) * 10000
        ) / 100
      );
    }
  }
};
